import moment from 'moment-timezone'
import i18n from '@src/i18n/i18n'

export const formatDate = (raw: string) => {
    const date = new Date(raw)
    if (!date) return raw

    const month = date.getMonth() > 8 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
    const day = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
    return `${date.getFullYear()}-${month}-${day}`
}

export const formatTime = (raw: string) => {
    return raw.slice(0, 5);
}

export const getCurrentTimeHM = () => {
    const dt = new Date()
    const hours = dt.getHours() > 9 ? dt.getHours() : `0${dt.getHours()}`;
    const minutes = dt.getMinutes() > 9 ? dt.getMinutes() : `0${dt.getMinutes()}`;
    return `${hours}:${minutes}`
}

export const getCurrentDateTimeIso = () => {
    const dt = new Date()
    return dt.toISOString()
}

export const getCurrentDateStr = () => {
    const dt = new Date()
    const month = dt.getMonth() > 8 ? dt.getMonth() + 1 : `0${dt.getMonth() + 1}`;
    const day = dt.getDate() > 9 ? dt.getDate() : `0${dt.getDate()}`;
    return `${dt.getFullYear()}-${month}-${day}`
}

export const getCurrentStartDateIso = () => {
    const dt = new Date();
    dt.setHours(0, 0, 0, 0); // обнуляем время
    const local = moment.tz(dt.toISOString(), 'Asia/Tokyo');
    return local.format();
}

export const getTimeFromDT = (raw: string, withSeconds: boolean = false) => {
    const dt = new Date(raw)
    const hours = dt.getHours() > 9 ? dt.getHours() : `0${dt.getHours()}`;
    const minutes = dt.getMinutes() > 9 ? dt.getMinutes() : `0${dt.getMinutes()}`;
    const seconds = dt.getSeconds() > 9 ? dt.getSeconds() : `0${dt.getSeconds()}`;
    if (withSeconds) return `${hours}:${minutes}:${seconds}`
    return `${hours}:${minutes}`
}

export const formatMsToJpTime = (ms: number): string => {
    const totalMinutes = Math.floor(ms / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    const hoursStr = i18n.t('time_hours', {hours})
    const minutesStr = i18n.t('time_minutes', {minutes})
    const result = `${hoursStr}${minutesStr}`

    return result || i18n.t('time_zero');
};

export const strToTime = (timeStr: string) => {
    const [h1, m1, s1] = timeStr.split(":").map(Number);
    if (!s1) return (h1 * 3600 + m1 * 60) * 1000;
    return (h1 * 3600 + m1 * 60 + s1) * 1000;
}

export const getTimeDiffMs = (timeOne: string = "23:59:59", timeTwo: string = "00:00:00") => {
    let diff = strToTime(timeOne) - strToTime(timeTwo);
    if (diff < 0) diff += 24 * 3600 * 1000; // корректировка через полночь
    return diff;
}
